import { useSelector, useDispatch } from "react-redux";
import {
    updateSelectedComplementaryRoomIdsArrayClearArray,
    updateMarkComplimentartRoomsDrawerVisible,
    updateSelectedComplementaryRoomIdsArrayRemoveRoom,
    updateSelectedComplementaryRoomIdsArrayAddRoom,
    updateSelectedComplementaryRoomIdsArraySaveSelected
} from "../.././../../reducer/bookingReducer";
import Drawer from "@mui/material/Drawer";
import { IoCloseSharp } from "react-icons/io5";
import {  FormGroup } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const MarkComplimentaryRoomsDrawer = () => {
    const {
        markComplimentaryRoomsDrawerVisible,
        selectedRoomWTypeAndNum,
        selectedComplementaryRoomIdsArrayInDrawer,
    } = useSelector((store) => store.booking);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(updateSelectedComplementaryRoomIdsArrayClearArray());
        dispatch(updateMarkComplimentartRoomsDrawerVisible(false));
    }
    let roomsList = Object.values(selectedRoomWTypeAndNum);
    if (roomsList.length > 0) {
        roomsList = roomsList.flat();
    }

    const handleCheckBoxSelectUnSelect = (event)=>{
        const {checked} = event.target;
        const roomId = event.target.name;
        if(checked){
            dispatch(updateSelectedComplementaryRoomIdsArrayAddRoom(roomId));
        } else {
            dispatch(updateSelectedComplementaryRoomIdsArrayRemoveRoom(roomId));
        }
    }

    const isRoomSelected = (roomId)=>{
        return selectedComplementaryRoomIdsArrayInDrawer.includes(roomId)
    }

    const handleMarkRoomsComplimentary = ()=>{
        dispatch(updateSelectedComplementaryRoomIdsArraySaveSelected());
        handleClose();
    }
    return (
        <Drawer
            PaperProps={{
                sx: {
                    width: "35%",
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                },
            }}
            sx={{
                "& .MuiDrawer-root": {
                    position: "absolute",
                    marginLeft: "auto",

                    right: 0,
                },
                "& .MuiPaper-root": {
                    position: "absolute",

                    marginLeft: "auto",
                },
            }}
            anchor={"bottom"}
            open={markComplimentaryRoomsDrawerVisible}
            onClose={() => handleClose()}
        >
            <div>

            </div>
            <div className="flex flex-col mx-3 gap-5 items-start my-4   ">
                <div className="flex w-[100%] justify-between items-center ">
                    <h2 className="font-[500] text-[1rem] text-[#4D4D4D] font-outfit">
                        Select Rooms To mark as complimentary
                    </h2>

                    <div className="flex gap-1 items-center cursor-pointer ">
                        <div
                            className="bg-[#4D4D4D] w-[16px] h-[16px] rounded-[50%] flex justify-center items-center "
                            onClick={() => dispatch(updateMarkComplimentartRoomsDrawerVisible(false))}
                        >
                            <IoCloseSharp className="text-[10px] text-[#FFF] " />
                        </div>
                    </div>
                </div>
                <div className="flex w-[100%] justify-between items-center ">
                    <FormGroup>
                        { roomsList?.map(room => {
                                return (
                                    <FormControlLabel
                                        key={room?.id}
                                        control={
                                            <Checkbox
                                                name={room?.id}
                                                checked={isRoomSelected(room?.id)}
                                                onChange={handleCheckBoxSelectUnSelect}
                                            />
                                        }
                                        label={room?.name}
                                    />
                                    // <div></div>
                                );
                            }
                        )}
                    </FormGroup>
                </div>
            </div>

            <button
                className="bg-[#007FFF] text-[#FFF] w-full h-[3rem] font-[600] text-[1.125rem] font-outfit tracking-[0.03125rem]"
                onClick={handleMarkRoomsComplimentary}
            >
                Mark Rooms Complimentary
            </button>
        </Drawer>

    );
}

export default MarkComplimentaryRoomsDrawer;